<script>
/**
 * Exhibits page - now uses ExhibitPage component with composition API
 * This file serves as an alias for backward compatibility
 */
import ExhibitPage from './ExhibitPage.vue';
export default ExhibitPage;
</script>
